import React, { useState } from 'react';
import { string, object, func } from 'prop-types';
import { Slide } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import useTimeout from 'Services/helpers/useTimeout';
import styles from './styles.scss';

const Snackbar = ({
  message, options, snackbarDelete,
}) => {
  const [isIn, setIsIn] = useState(true);
  useTimeout(() => setIsIn(false), 5000, { persistRenders: true });
  return (
    <Slide
      appear
      direction='up'
      in={isIn}
      onExited={snackbarDelete}
      timeout={{
        enter: 225,
        exit: 195,
      }}
    >
      <Alert
        {...options}
        classes={{ root: styles.snackbarItem }}
        variant='filled'
      >
        {message}
      </Alert>
    </Slide>
  );
};

Snackbar.propTypes = {
  id: string.isRequired,
  message: string.isRequired,
  options: object,
  snackbarDelete: func.isRequired,
};

export default Snackbar;
